import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";
import cursorIcon from "assets/img/Cursor.png";

export const InstitutionsContactContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
`;

export const TitleSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const HeaderSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};
  padding-block: 0 ${SIZE.max40};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: 0;
  }
`;

export const ContentSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const BackToWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  width: fit-content;
  transition: 0.3s ease-out;
  :hover {
    filter: brightness(0.7);
  }
`;

export const BackToGuidesImage = styled.img`
  margin-right: 8px;
  svg {
    width: 10px;
    height: 16px;
  }
  transform: rotate(90deg);
`;

export const BackToGuidesButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const ContactCardsWrapper = styled.div<{ $hasWebsites: boolean }>`
  --contact-columns: ${({ $hasWebsites }) => $hasWebsites
    ? "minmax(0, 1.25fr) minmax(0, 0.8fr) minmax(0, 1.25fr) minmax(0, 1fr)"
    : "minmax(0, 1.3fr) minmax(0, 0.85fr) minmax(0, 1.35fr)"};
  display: flex;
  flex-direction: column;
  gap: ${SIZE.max24};
  padding-block: 0 ${SIZE.max40};
`;

export const ContactCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  padding: ${SIZE.max32};
  display: flex;
  flex-direction: column;
`;

export const ContactCardTitleWrapper = styled.div`
  margin-bottom: ${SIZE.max16};
`;

export const ContactCardContentWrapper = styled.dl`
  display: grid;
  grid-template-columns: var(--contact-columns);
  align-items: start;
  gap: ${SIZE.max24};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${DEVICE_TYPE.mobile}) {
    grid-template-columns: minmax(0, 1fr);
    gap: ${SIZE.max16};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow-wrap: anywhere;

  dt { margin-bottom: 4px; }
  dd { display: flex; flex-direction: column; gap: 4px; }

  @media (max-width: ${DEVICE_TYPE.mobile}) {
    & + & { border-top: 1px solid ${COLORS.lineColor}; padding-top: ${SIZE.max16}; }
  }
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max400};
    width: ${SIZE.max400};
  }
`;
